export default class LearnMore {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.mouse = document.querySelector(".visual__mouse");
        this.text = document.querySelector(".visual__perex strong");
        this.section = document.querySelectorAll(".page__content section")[1];

        this.bindEvents();
    }
    bindEvents() {
        this.mouse.addEventListener("click", e => this.scrollToNextSection(e));
        if (this.text) {
            this.text.addEventListener("click", e =>
                this.scrollToNextSection(e)
            );
        }
    }
    scrollToNextSection(e) {
        var headerOffset = 65;
        var elementPosition = this.section.getBoundingClientRect().top;
        var offsetPosition = elementPosition - headerOffset;
        window.scrollBy({
            top: offsetPosition
        });
    }
}
